import type { Option } from '@/components/UI/Form/types'

import { MINUTES_PER_HOUR } from './time'

export const INCREMENTS_IN_ONE_HOUR = 4

export function timeOptionValueFrom({
  hours,
  minutes,
}: {
  hours: number
  minutes: number
}): string {
  const fraction = minutes / 60
  return `${hours + fraction}`
}

function getTimeOption({ hours, minutes }: { hours: number; minutes: number }): Option {
  const label = hours === 0 || hours === 12 ? 12 : hours % 12
  const minuteString = minutes.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  })
  return {
    value: timeOptionValueFrom({ hours, minutes }),
    label: `${label}:${minuteString} ${hours < 12 ? 'AM' : 'PM'}`,
  }
}

/*
    creates a list of all time options based on `INCREMENTS_IN_ONE_HOUR`.
    For example: [{value: 0, label: "12:00 AM"},
                  {value: 0.25, label: "12:15 AM"},
                  {value: 0.5, label: "12:30 AM"}
                  {value: 0.75, label: "12:45 AM"}
                  ...]
    if there are 4 increments.
*/
export default function getTimeOptions(
  start = 0,
  end = 24
  // ^ Note that end is inclusive for all cases except when start = 0 AND end = 24.
  // This is because 0-24 should yield 12:00 AM - 11:45 PM.
): Option[] {
  const times: Option[] = []

  for (let hours = start; hours < end; hours += 1) {
    for (let i = 0; i < INCREMENTS_IN_ONE_HOUR; i += 1) {
      const minutes = (MINUTES_PER_HOUR / INCREMENTS_IN_ONE_HOUR) * i
      times.push(getTimeOption({ hours, minutes }))
    }
  }

  // Make it inclusive unless time range is from 12:00 AM - 11:45 PM.
  if (!(start === 0 && end === 24)) {
    times.push(getTimeOption({ hours: end, minutes: 0 }))
  }

  return times
}
